import * as classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import './styles.scss';
import { Box } from 'signoxe/components/layout';
import { Button, Popup, FeedPopup, Icon } from 'signoxe/components/widgets';


const Popup = ({ children, title, modal, onCancel, className, style }) => (
  <div className={classnames('popup-outer', { 'modal': modal }, className)} onClick={onCancel}>
    <div className="popup-inner depth-5" style={style} onClick={(e) => e.stopPropagation()}>
      {title && <h4>{title}</h4>}
      {children}
    </div>
  </div>
);

export const FeedPopup = ({ children, title, modal, onCancel, className, cb, toggleDeviceId }) => (
  <div className={classnames('popup-outer', { 'modal': modal }, className)} onClick={onCancel}>
    <div className="popup-inner depth-5" onClick={(e) => e.stopPropagation()}>
      <Box className='feed-header' justifyContent="space-between">
        <h4>Update Content Feed</h4>
        {
          cb ?
            <Button className='small add-feed-btn ml-move' primary onClick={() => cb()}>
              Add Feed <Icon name="plus" color='#fff' size="1rem" title="Add Feed" />
            </Button>
            : null
        }
        <Button className='small add-feed-btn ' primary onClick={() => toggleDeviceId(null)} >
          <Icon name="times" color='#fff' size="1.1rem" />
        </Button>
      </Box>
      {children}
    </div>
  </div>
)

Popup.propTypes = {
  children: PropTypes.node,
  modal: PropTypes.bool,
  onCancel: PropTypes.func,
  className: PropTypes.string,
  title: PropTypes.string,
};

export default Popup;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/Popup/index.js